<template>
    <b-overlay :show="loading" rounded="sm">
        <li class="nav-item dropdown mr-sm-2">

            <a id="navbarDropdownOrganization" class="nav-link dropdown-toggle pr-0" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">

                <span v-if="actual_organization" class="d-inline-flex align-items-center">
                    <span class="badge badge-secondary text-light mr-2" v-b-tooltip.hover title="Código da Escola">
                        {{ actual_organization.code }}
                    </span>
                    <span class="d-inline-block d-sm-none">
                        {{ actual_organization.name | truncate(10) }}
                    </span>
                    <span class="d-none d-sm-inline-block">
                        {{ actual_organization.name }}
                    </span>
                </span>

                <span v-else>
                    ---
                </span>

                <span class="caret"></span>
            </a>

            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdownOrganization">

                <a class="dropdown-item d-inline-flex align-items-center" href="javascript:;" v-for="organization in organizations" :key="organization.id" :class="{'active': organization.id === actualOrganizationId }" @click="changeOrganization(organization.id)">
                    <span class="badge badge-secondary text-light mr-2" v-b-tooltip.hover title="Código da Escola">
                        {{ organization.code }}
                    </span>

                    {{ organization.name }}
                </a>

                <div class="dropdown-divider" v-if="organizations.length !== 0"></div>

                <a class="dropdown-item" :href="endpointCreateOrganization">
                    <i class="fas fa-plus mr-1"></i> Criar Organização
                </a>

                <a class="dropdown-item" :href="endpointEnterOrganization">
                    <i class="fas fa-sign-in-alt mr-1"></i> Ingressar com Código
                </a>

            </div>
        </li>
    </b-overlay>
</template>

<script>
export default {
    props: [
        'endpointOrganizations',
        'endpointChangeOrganization',
        'endpointCreateOrganization',
        'endpointEnterOrganization'
    ],
    data() {
        return {
            loading: false,
            organizations: [],
            actual_organization: null
        }
    },
    computed: {

        actualOrganizationId() {
            if (this.actual_organization !== null) {
                return this.actual_organization.id
            }

            return false;
        }

    },
    created() {

        this.loadOrganizations()

    },
    methods: {

        loadOrganizations() {
            this.loading = true;
            axios.get(this.endpointOrganizations)
                .then((result) => {
                    const response = result.data.data

                    this.organizations = response.organizations
                    this.actual_organization = response.actual_organization
                })
                .finally(() => this.loading = false)
        },

        changeOrganization(organization_id) {
            this.loading = true;
            axios.put(this.endpointChangeOrganization, {
                organization_id: organization_id
            })
                .then((result) => {
                    // Redirect
                    this.redirectIfNeed(result)
                })
                .finally(() => this.loading = false)
        }
    }
}
</script>

<style scoped>

</style>
